import { useEffect, useState } from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core';

const height = 80;
const mobile_height = 64;

const useStyles = makeStyles((theme) => ({
  header: {
    height,
    position: 'fixed',
    top: 0,
    right: 0,
    left: 0,
    zIndex: 100,
    background: 'white',
    transition:
      'top 250ms cubic-bezier(0.4, 0, 0.2, 1),background-color 250ms ease',

    '&$transform': {
      top: '32px',
      background: 'transparent',

      '& $wrapper': {
        backgroundColor: '#fff',
        borderRadius: '24px',
        boxShadow: '0 0 30px rgba(64, 62, 41, 0.1)',
        maxWidth: 'calc(1320px + 32px + 32px)',
        paddingLeft: theme.spacing(8),
        paddingRight: theme.spacing(8),

        [theme.breakpoints.down('xs')]: {
          borderRadius: '0px',
          backgroundColor: '#fff',
          boxShadow: '0px 4px 8px rgba(64, 62, 41, 0.18)',
          maxWidth: 'calc(1320px + 32px + 32px)',
          paddingLeft: theme.spacing(3),
          paddingRight: theme.spacing(3),
        },
      },
      [theme.breakpoints.down('sm')]: {
        top: 0,
      },
    },
    [theme.breakpoints.down('sm')]: {
      height: mobile_height,
    },
  },
  transform: {},
  wrapper: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    maxWidth: 'calc(1320px + 32px + 32px)',
    margin: 'auto',
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    transition: 'all 250ms cubic-bezier(0.4, 0, 0.2, 1)',

    [theme.breakpoints.down('sm')]: {
      boxShadow: '0px 4px 8px rgba(64, 62, 41, 0.18)',
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),

      paddingTop: theme.spacing(1.4),
    },
  },
}));

// NOTE: loading not implemented for this type of layout
const LandingHeader = (props) => {
  const { children, className /* , loading */ } = props;

  const [isTransform, setIsTransform] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    const onScroll = () => {
      setIsTransform(window.scrollY > 0);
    };
    window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  const rootClasses = cx(
    className,
    classes.header,
    isTransform && classes.transform,
  );

  return (
    <>
      <div className={rootClasses}>
        <div className={classes.wrapper}>{children}</div>
      </div>
    </>
  );
};

export default LandingHeader;
